// @ts-ignore
import module from './module/index'

export default module
